export default __webpack_public_path__ + "locales/cs/DeleteDialog.json?hash=7857959bf55e6ff6cdd9df7f3f805b37";